import React from "react";

export const IconWrapper = ({
  children,
  className = "",
  size = 24,
  ...props
}) => {
  return React.cloneElement(children, {
    width: size,
    height: size,
    className: `${className}`,
    style: {
      flexShrink: 0,
      lineHeight: 1,
      ...(props.style || {}),
    },
    ...props,
  });
};

export default IconWrapper;
